import React from 'react';
import CloseIconSvg from './CloseIcon.svg';

const CloseIcon = (props) => (
    /* TODO - change to 'webpack inlined' when on react-scripts 2.0 - https://facebook.github.io/create-react-app/docs/adding-images-fonts-and-files#adding-svgs */
    <img src={CloseIconSvg} alt="Close" {...props} />
);

export default CloseIcon;
